import { useLocalization } from '@components/Localization'
import { Box, breakpoints, Container, Image, Track, useSlider } from '@gassan-ui'
import { useBreakpoint } from '@lib/hooks/useBreakpoint'
import { getKontentImage } from '@lib/kontent'
import { RolexKeepExploringSliderItem } from '@lib/kontent/models/RolexKeepExploringSliderItem'
import { Heading } from '@rolex-ui'
import _chunk from 'lodash.chunk'
import { useRouter } from 'next/router'
import { rem } from 'polished'
import React, { FC, Fragment, useRef } from 'react'
import Indicators from '../Indicators'
import SliderNavButton from '../SliderNavButton'
import * as S from './elements'

type Props = {
  items: RolexKeepExploringSliderItem[]
  title: string
}

const KeepExploring: FC<Props> = ({ items, title }) => {
  const { lang } = useLocalization()
  const { asPath } = useRouter()
  const isTabletUp = useBreakpoint(breakpoints.small)
  const chunks = _chunk(items, isTabletUp ? 3 : 2)
  const trackRef = useRef<HTMLElement>(null)
  const { onTouchEnd, prev, next, canMoveRight, canMoveLeft, index, goToIndex } = useSlider({
    trackRef
  })
  return (
    <Container
      maxWidth={{ _: '90%', large: rem(1140) }}
      mb={{ _: '3rem', small: '6rem', large: '7.5rem' }}
    >
      <Heading variant="verySmallTitle" as="h2" mb="1.25rem">
        {title}
      </Heading>
      <Box mb={{ _: rem(30), medium: rem(35), large: '2.5rem' }} position="relative">
        <Track ref={trackRef} onTouchEnd={onTouchEnd}>
          {chunks.map((chunk, key) => (
            <Fragment key={key}>
              <S.Slide
                display="grid"
                gridTemplateColumns={{ _: '1fr 1fr', small: '1fr 1fr 1fr' }}
                gridColumnGap="1rem"
                minWidth="100%"
              >
                {chunk.map((item, key) => (
                  <S.Item
                    isActive={asPath === `/${lang}${item.url.value}`}
                    href={`/${lang}${item.url.value}`}
                    key={key}
                  >
                    <Image
                      ratio={1.1}
                      alt={item.image.value[0].description}
                      sources={[
                        getKontentImage(item.image.value[0].url, { width: 300 }),
                        getKontentImage(item.image.value[0].url, { width: 500 })
                      ]}
                      placeholder={getKontentImage(item.image.value[0].url, { width: 30 })}
                    />
                    <S.Title bg="white">
                      <Heading variant="gridTitle" as="h3" pt=".625rem">
                        {item.title.value}
                      </Heading>
                    </S.Title>
                  </S.Item>
                ))}
              </S.Slide>
              <Box p="0.5rem" />
            </Fragment>
          ))}
        </Track>
        {chunks.length > 1 && (
          <S.NavButtons>
            <SliderNavButton direction="prev" onClick={prev} disabled={!canMoveLeft} />
            <SliderNavButton direction="next" onClick={next} disabled={!canMoveRight} />
          </S.NavButtons>
        )}
      </Box>
      {chunks.length > 1 && (
        <Indicators
          activeIndex={index}
          onClick={index => {
            goToIndex(index)
          }}
          count={chunks.length}
        />
      )}
    </Container>
  )
}

export default KeepExploring
